var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, } from 'react-router';
import { errors } from '@feathersjs/client';
import * as Raven from 'raven-js';
import { resetWorkspaceEvent, setWorkspaceEventEvent, setWorkspaceEventService, } from '../../reducers/workspaceEvent/actions';
import { resetScoreboard } from 'src/imports/components/Scoreboard/reducers/actions';
import PageLoading from '../PageLoading';
import PageEventNotFound from '../PageEventNotFound';
import PageScoreboard from './PageScoreboard';
import { feathersServices } from 'src/feathers';
var WorkspaceEvent = (function (_super) {
    __extends(WorkspaceEvent, _super);
    function WorkspaceEvent(props) {
        var _this = _super.call(this, props) || this;
        _this.subscriber = {};
        _this.state = {
            isFetching: true,
            isError: false,
        };
        _this.hydrateWorkspace = _this.hydrateWorkspace.bind(_this);
        _this.subscribeToWorkspace = _this.subscribeToWorkspace.bind(_this);
        _this.unsubscribeFromWorkspace = _this.unsubscribeFromWorkspace.bind(_this);
        return _this;
    }
    WorkspaceEvent.prototype.componentWillMount = function () {
        var hostname = process.env.CLIENT_HOSTNAME;
        var subdomain = hostname
            ? window.location.host.split(hostname)[0].slice(0, -1)
            : window.location.host.split('.')[0];
        this.hydrateWorkspace(subdomain);
    };
    WorkspaceEvent.prototype.componentWillUnmount = function () {
        this.unsubscribeFromWorkspace();
    };
    WorkspaceEvent.prototype.componentWillReceiveProps = function (nextProps) {
        var workspaceEvent = nextProps.workspaceEvent;
        if (workspaceEvent.event &&
            workspaceEvent.categories &&
            workspaceEvent.rounds &&
            workspaceEvent.routes &&
            workspaceEvent.teams &&
            workspaceEvent.teamScores &&
            workspaceEvent.athletes &&
            workspaceEvent.athleteScores) {
            this.setState({ isFetching: false });
        }
        else {
            this.setState({ isFetching: true });
        }
    };
    WorkspaceEvent.prototype.hydrateWorkspace = function (subdomain) {
        return __awaiter(this, void 0, void 0, function () {
            var eventResponse, event_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (subdomain.length < 6) {
                            this.setState({
                                isFetching: false,
                                isError: true,
                                errorTitle: 'No event found',
                                errorMessage: 'You may have misspelt the event\'s web address',
                            });
                            return [2];
                        }
                        this.setState({
                            isFetching: true,
                            isError: false,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.props.dispatch(feathersServices.events.find({
                                query: { subdomain: subdomain },
                                $limit: 1,
                            }))];
                    case 2:
                        eventResponse = _a.sent();
                        if (eventResponse.value.total !== 1) {
                            throw new errors.NotFound("We could not find an event at \"" + subdomain + ".crimp.rocks\"");
                        }
                        event_1 = eventResponse.value.data[0];
                        if (!event_1) {
                            throw new errors.NotFound("We could not find any event at \"" + subdomain + ".crimp.rocks\".");
                        }
                        this.unsubscribeFromWorkspace();
                        this.subscribeToWorkspace(event_1);
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        this.setState({
                            isFetching: false,
                            isError: true,
                            errorTitle: '404',
                            errorMessage: err_1.message,
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    WorkspaceEvent.prototype.subscribeToWorkspace = function (event) {
        var _this = this;
        var services = [
            'categories',
            'rounds',
            'routes',
            'teams',
            'teamScores',
            'athletes',
            'athleteScores',
            'actives',
        ];
        var searchQuery = {
            query: {
                eventId: event.id,
                $limit: 1000,
                $sort: { id: 1 },
            },
        };
        this.subscriber.event = feathersClient.service('events')
            .watch({ listStrategy: 'always' })
            .find({
            query: {
                id: event.id,
                $limit: 1,
                $sort: { id: 1 },
            },
        })
            .subscribe(function (res) {
            _this.props.dispatch(setWorkspaceEventEvent(res));
        }, function (err) { Raven.captureException(err); });
        services.forEach(function (s) {
            _this.subscriber[s] = feathersClient.service(s)
                .watch({ listStrategy: 'always' })
                .find(searchQuery)
                .subscribe(function (res) {
                _this.props.dispatch(setWorkspaceEventService(s, res));
            }, function (err) { Raven.captureException(err); });
        });
    };
    WorkspaceEvent.prototype.unsubscribeFromWorkspace = function () {
        var _this = this;
        Object.keys(this.subscriber).forEach(function (key) {
            if (_this.subscriber[key]) {
                _this.subscriber[key].unsubscribe();
            }
        });
        this.subscriber = {};
        this.props.dispatch(resetWorkspaceEvent());
        this.props.dispatch(resetScoreboard());
    };
    WorkspaceEvent.prototype.render = function () {
        if (this.state.isError) {
            return React.createElement(PageEventNotFound, { errorMessage: this.state.errorMessage });
        }
        if (this.state.isFetching) {
            return React.createElement(PageLoading, { loadMessage: 'Setting down pads...' });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Switch, null,
                React.createElement(Route, { path: '/', component: PageScoreboard }),
                React.createElement(Route, { component: PageEventNotFound }))));
    };
    return WorkspaceEvent;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceEvent: state.workspaceEvent,
}); };
export default connect(mapStateToProps)(WorkspaceEvent);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/index.tsx
// module id = 483
// module chunks = 0